import '../style/scroller-CzQBxmt_.css'
import { defineComponent as t, useCssVars as c, unref as o, openBlock as p, createElementBlock as f, normalizeClass as i, renderSlot as m } from "vue";
import { useScroller as d } from "./hooks/useScroller.js";
const y = /* @__PURE__ */ t({
  name: "e-scroller",
  __name: "scroller",
  props: {
    fat: { type: Boolean },
    horizontal: { type: Boolean },
    showScrollbarOnHover: { type: Boolean },
    hideScrollbar: { type: Boolean }
  },
  setup(r) {
    c((e) => ({
      "57c4f3aa": o(n)
    }));
    const l = r, { scroller: s, classList: a, edgePaddingOnHover: n } = d(l);
    return (e, u) => (p(), f("div", {
      ref_key: "scroller",
      ref: s,
      class: i(o(a))
    }, [
      m(e.$slots, "default")
    ], 2));
  }
});
export {
  y as default
};
//# sourceMappingURL=scroller.js.map
